import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchPartnersItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { PartnersItem } from '../PartnersItem';

interface PartnersCategoryProps {
  data: GlobalSearchCategory<GlobalSearchPartnersItem>;
}

export const PartnersCategory = ({ data }: PartnersCategoryProps) => {
  const { search, partnersTypes } = useGetMainSearchQuery();

  return (
    <CategoryWrapper
      categoryName="Partners"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({
        category: SEARCH_CATEGORIES.PARTNERS,
        searchQuery: search,
        partners: partnersTypes,
      })}
    >
      {data.results.map((item, index) => (
        <PartnersItem key={`${item.title}-${index}`} item={item} />
      ))}
    </CategoryWrapper>
  );
};